export const calculateMonorielAmericano = (width, height) => {
  const verticalElements = {
        'Marco': Math.floor(height + 56),
        'Hoja Normal': Math.floor(height - 49),
        'Traslapo Fijo': Math.floor(height - 45),
        'Traslapo Movil': Math.floor(height - 49),
  };

  const horizontalElements = {
    'Marco': Math.floor(width + 56),
    'Hoja Normal': Math.floor(width / 2 + 11.4),
    'Junquillo': Math.floor(width - 232),
    'Riel Guia': Math.floor(width - 27),
  };

  // Calcular barras necesarias
  const barrasNecesarias = {};
  const largoBarra = 6000; // mm

  // Cantidades específicas para cada perfil vertical
  const cantidadesVerticales = {
    'Marco': 2,
    'Hoja Normal': 1,
    'Traslapo Fijo': 1,
    'Traslapo Movil': 1
  };

  // Cantidades específicas para cada perfil horizontal
  const cantidadesHorizontales = {
    'Marco': 2,
    'Hoja Normal': 2,
    'Junquillo': 2,
    'Riel Guia': 1
  };

  // Procesar elementos verticales
  for (const [perfil, largo] of Object.entries(verticalElements)) {
    const cantidadPiezas = cantidadesVerticales[perfil];
    const piezasVerticales = Array(cantidadPiezas).fill(largo);
    
    barrasNecesarias[perfil] = {
      cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
      desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
      piezasVerticales,
      piezasHorizontales: [],
      largoTotal: largo * cantidadPiezas
    };
  }

  // Procesar elementos horizontales
  for (const [perfil, largo] of Object.entries(horizontalElements)) {
    const cantidadPiezas = cantidadesHorizontales[perfil];
    const piezasHorizontales = Array(cantidadPiezas).fill(largo);
    
    if (!barrasNecesarias[perfil]) {
      barrasNecesarias[perfil] = {
        cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
        desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
        piezasVerticales: [],
        piezasHorizontales,
        largoTotal: largo * cantidadPiezas
      };
    } else {
      const largoTotalCombinado = (largo * cantidadPiezas) + barrasNecesarias[perfil].largoTotal;
      barrasNecesarias[perfil] = {
        ...barrasNecesarias[perfil],
        cantidadBarras: Math.ceil(largoTotalCombinado / largoBarra),
        desperdicioMm: (Math.ceil(largoTotalCombinado / largoBarra) * largoBarra) - largoTotalCombinado,
        piezasHorizontales,
        largoTotal: largoTotalCombinado
      };
    }
  }

  return {
    vertical: verticalElements,
    horizontal: horizontalElements,
    barrasNecesarias,
    type: 'Monoriel Americano',
    photo: 'https://cdnx.jumpseller.com/alumsur/image/33028200/resize/960/960?1678476266',
  };
};

export const calculateVidriosMonorielAmericano = (height, width) => {
  // Aseguramos que los valores sean números enteros
  const numericHeight = Math.floor(Number(height));
  const numericWidth = Math.floor(Number(width));

  return {
    fijo: {
      vertical: Math.floor(numericHeight - 104),
      horizontal: Math.floor((numericWidth / 2) - 53)
    },
    movil: {
      vertical: Math.floor(numericHeight - 43),
      horizontal: Math.floor((numericWidth / 2) - 36)
    }
  };
};
